module.exports = __webpack_public_path__ + "static/universal_solvent_mtg_clb-63ff0894a43c680bc14e81a470ac519f.webp";